import React from "react";
import styled from "styled-components";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import ChevronDownIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ChevronDownIconPath";
import InformationCircleIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/InformationCircleIconPath";
import { LocalCombinationDeletedMessageModal } from "../Organisms/Modals/LocalCombinationDeletedInfoModal";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";

const BACKGROUND_COLOR = "var(--grey100)";

const LocalCombinationAccordionContainer = styled("div")<{ isOpen: boolean }>`
  margin: 5px 0 16px 0;
  background-color: ${BACKGROUND_COLOR};
  cursor: pointer;
  position: relative;
  border-radius: 16px;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 100%);
    border-width: 16px;
    border-style: solid;
    border-color: ${({ isOpen }) =>
      isOpen
        ? `${BACKGROUND_COLOR} transparent transparent transparent`
        : "transparent"};
    transition: border-color 0.3s ease;
  }
`;

const LocalCombinationAccordionWrapper = styled("div")`
  margin: 0 16px;
  border-radius: 16px;
  overflow: hidden;
`;

const AccordionHeader = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  height: 24px;
  background-color: ${BACKGROUND_COLOR};
  border-radius: 16px;
`;

const AccordionTitle = styled("div")`
  font-size: 12px;
  font-weight: bold;
  text-align: left;
`;

const ChevronIcon = styled("div")<{ isOpen: boolean }>`
  width: 24px;
  height: 24px;
  display: flex;
  transition: transform 0.3s ease;
  transform: ${({ isOpen }) => (isOpen ? "rotate(180deg)" : "rotate(0deg)")};
`;

interface LocalCombinationAccordionProps {
  title: string;
  isOpen: boolean;
  showInfoIcon: boolean;
  onClick: () => void;
}

export const LocalCombinationAccordion: React.FC<
  LocalCombinationAccordionProps
> = ({ title, isOpen, showInfoIcon, onClick }) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const onClickInfoCircle = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsModalOpen(true);
  };

  return (
    <>
      <LocalCombinationAccordionWrapper key={title}>
        <LocalCombinationAccordionContainer isOpen={isOpen} onClick={onClick}>
          <AccordionHeader>
            <AccordionTitle>{title}</AccordionTitle>
            {showInfoIcon ? (
              <FixaButton
                onClick={onClickInfoCircle}
                ssrIcon={InformationCircleIconPath}
                type={"tertiary"}
                iconOnly
              />
            ) : (
              <ChevronIcon isOpen={isOpen}>
                <FixaSSRIcon paths={ChevronDownIconPath} />
              </ChevronIcon>
            )}
          </AccordionHeader>
        </LocalCombinationAccordionContainer>
      </LocalCombinationAccordionWrapper>
      {isModalOpen && (
        <LocalCombinationDeletedMessageModal
          message={"showModalMessage"}
          closeModal={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};
